import { isNative } from "./platform";

/** Whether to show the "Capture" affordance (native only). */
export function cameraAvailable(): boolean {
  return isNative();
}

/**
 * Capture a photo (camera or gallery) and return it as a JPEG File, ready to
 * drop into the same multipart upload the file <input> feeds. Native-only.
 */
export async function captureImageAsFile(name = "capture.jpg"): Promise<File> {
  if (!isNative()) throw new Error("camera is native-only");
  const { Camera, CameraResultType, CameraSource } = await import("@capacitor/camera");
  const photo = await Camera.getPhoto({
    quality: 80,
    resultType: CameraResultType.Uri,
    source: CameraSource.Prompt, // let the user pick camera or gallery
    correctOrientation: true,
  });
  const resp = await fetch(photo.webPath!);
  const blob = await resp.blob();
  return new File([blob], name, { type: blob.type || "image/jpeg" });
}

/**
 * Wrap one or more Files in a real FileList so they can be handed to state that
 * a `<input type="file">` normally sets (via DataTransfer, supported in the
 * Android WebView). Keeps the existing upload handlers untouched.
 */
export function filesToFileList(files: File[]): FileList {
  const dt = new DataTransfer();
  for (const f of files) dt.items.add(f);
  return dt.files;
}
